export default __webpack_public_path__ + "static/media/portis.5efa3349.svg";